import type { DeepPartial } from '@luna/utils-ts';

import type { Pip } from '../../types/Pip';

export const pipSKFeatureConfig: DeepPartial<Pip> = {
    shouldShowBackNavigationOnOrderSummary: true,
    shouldShowFullCatalogueLink: true,
    tilePriceHistoryExchangeCode: 'ESPAPL',
};
